export default __webpack_public_path__ + "static/media/actividad-31.1facd1c0.mp3";